import { AxiosResponse } from 'axios';
import dayjs from 'dayjs';

import {
  InsurancePolicy,
  PolicyStates,
  BranchGroup,
  PossessionsType,
  RELATION_BRANCH_WITH_POSSESSIONS,
  ClaimsPerPolicyResponse,
  DECISION_TYPE,
  BINARY_VALUES,
} from '../../interfaces';

export const getInsurancePolicyStates = (
  insurancePolicy: InsurancePolicy
): Array<PolicyStates> => {
  const states: Array<PolicyStates> = [];

  if (insurancePolicy.estaVigente === DECISION_TYPE.YES) states.push(PolicyStates.ACTIVE);
  if (insurancePolicy.estaVigente === DECISION_TYPE.NO) states.push(PolicyStates.INACTIVE);
  if (insurancePolicy.isAnulada === DECISION_TYPE.YES) states.push(PolicyStates.CANCELED);
  if(insurancePolicy.tieneSolicitudDeArrepentimiento === DECISION_TYPE.YES ) states.push(PolicyStates.IS_WITHDRAWAL_REQUEST);

  const diff = dayjs(insurancePolicy.fechaVigHast, 'YYYY-MM-DD').diff(
    dayjs(),
    'days'
  );

  if (diff > 0 && diff <= 15) states.push(PolicyStates.SOON_TO_EXPIRE);

  if (insurancePolicy.permiteRenovar === DECISION_TYPE.YES) states.push(PolicyStates.IS_RENEWAL);

  return states;
};

export const getPossessionsType = (branchGroup: BranchGroup): PossessionsType =>
  RELATION_BRANCH_WITH_POSSESSIONS[branchGroup];

export const checkClaimsResponse = (
  claims: AxiosResponse<ClaimsPerPolicyResponse | any>
): ClaimsPerPolicyResponse | any => {
  const emptyResponse = { siniestros: [{ pagos: [] }] };

  if (JSON.stringify(emptyResponse) === JSON.stringify(claims.data)) {
    return { siniestros: [] };
  }

  return claims;
};

export const checkPoliciesResponse = (
  policies: AxiosResponse<any>
): any => {
  const emptyResponse = { polizas: [{ beneficiariosPoliza: [] }] };

  if (JSON.stringify(emptyResponse) === JSON.stringify(policies.data)) {
    policies.data = { polizas: [] };
  }
  return policies;
};

export const fixEncoding = (str: string): string => {
  try {
    return decodeURIComponent(escape(str));
  } catch {
    return str;
  }
};